module.exports = __webpack_public_path__ + "img/comment-arrow.0b5e72b4.svg";